import * as React from 'react';
import { Outlet } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Sidenav from '../Sidenav/Sidenav'
import AccountDropdown from "./AccountDropdown/AccountDropdown";

import NotificationDropdown from "./NotificationDropdown/NotificationDropdown";

import { ReactComponent as Logo } from "../logo.svg";

// const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        height: '100%',
        width: '100%',
        flexGrow: 1,
        padding: theme.spacing(1),
        overflow: 'hidden',
    }),
);



export default function Home() {
    const [open, setOpen] = React.useState(true)
    const onSidenavOpen = (newMessage) => {
        setOpen(newMessage);
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <Box sx={{
                width: '100vw',
                height: '100vh'
            }}>
                <AppBar position='static' elevation={0} color='secondary' sx={{ background:' linear-gradient(270.96deg, #F0F6FF -30.28%, #F3FEF1 105.87%)'}}>
                    <Toolbar>
                        <Logo style={{ scale: '1.2', marginLeft: '16px' }} />
                        <Box sx={{ position: 'absolute', right: '24px', display: 'flex', alignItems: 'center', gap: '10px'}}>
                            <NotificationDropdown />
                            <AccountDropdown />
                        </Box>
                    </Toolbar>
                </AppBar>

                <Box sx={{
                    display: 'flex',
                    height: `calc(100vh - 65px)`,
                    overflow: 'auto'

                }}>
                    <Sidenav open={open} onSidenavOpen={onSidenavOpen}></Sidenav>
                    <Main open={open}>
                        <Outlet />
                    </Main>
                </Box>
            </Box>
        </React.Fragment>
    );
}
